import dispatcher from '../dispatcher';

var elementProto = Object.create(HTMLElement.prototype);

var _handleDispatcher = function(e) {
	if (e.type === 'indicator:on') {
		this._items[e.index].classList.add('active');
	}
	if (e.type === 'indicator:off') {
		this._items[e.index].classList.remove('active');
	}
	if (e.type === 'indicator:set-until') {
		Array.prototype.forEach.call(this._items, function(item, index) {
			if (index <= e.index) {
				item.classList.add('active');
			} else {
				item.classList.remove('active');
			}
		});
	}
}

elementProto.createdCallback = function() {
	this.handleDispatcher = _handleDispatcher.bind(this);
}
elementProto.attachedCallback = function() {
	this._items = this.getElementsByClassName('item');

	dispatcher.subscribe(this.handleDispatcher);
}
elementProto.detachedCallback = function() {
	dispatcher.unsubscribe(this.handleDispatcher);
}

document.registerElement('indicator-component', {
	prototype: elementProto
});